const SummaryCard = ({
  title,
  value,
  icon,
  valueColor = "text-gray-900",
  bgColor = "bg-white",
  iconBg = "bg-blue-100",
  iconColor = "text-blue-600",
  minWidth = "min-w-[140px] md:min-w-[180px]",
  formatValue,
}) => (
  <div className={`flex items-center ${bgColor} px-3 py-2 md:px-4 md:py-2 rounded-lg shadow border ${minWidth} w-full sm:w-auto`}>
    <div className={`flex-shrink-0 ${iconBg} ${iconColor} rounded-full p-2 mr-2 md:mr-3`}>
      {icon}
    </div>
    <div>
      <div className="text-xs text-gray-500 font-medium">{title}</div>
      <div className={`text-base md:text-lg font-bold leading-tight ${valueColor}`}>
        {formatValue ? formatValue(value) : value}
      </div>
    </div>
  </div>
);

export default SummaryCard;